
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/meet-our-techs",
      function () {
        return require("private-next-pages/meet-our-techs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/meet-our-techs"])
      });
    }
  